import { render, staticRenderFns } from "./Calendar-Setting.vue?vue&type=template&id=c20ac7bc"
import script from "./Calendar-Setting.vue?vue&type=script&lang=js"
export * from "./Calendar-Setting.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports